import classNames from 'classnames'
import { mountedCheck } from '../../library'

export default {
  data () {
    return {
      translateX: 0,
      cycleWidth: 0,
      repeatCount: 2,
      animationFrameId: null
    }
  },
  props: {
    message: {
      type: Array,
      default: () => {
        return []
      }
    },
    start: {
      type: Number,
      default: 0
    },
    speed: {
      type: Number,
      default: 60
    },
    delay: {
      type: Number,
      default: 1000
    }
  },
  mounted () {
    this.initializeMarquee()
    window.addEventListener('resize', this.initializeMarquee)
  },
  beforeDestroy () {
    this.stopAnimation()
    window.removeEventListener('resize', this.initializeMarquee)
  },
  watch: {
    message: {
      deep: true,
      handler () {
        this.initializeMarquee()
      }
    }
  },
  computed: {
    repeatedMessages () {
      if (!this.message.length) return []
      return Array.from({ length: this.repeatCount }).reduce((messages) => {
        return messages.concat(this.message)
      }, [])
    },
    isSingleMessage () {
      return this.message.length === 1
    }
  },
  methods: {
    stopAnimation () {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
        this.animationFrameId = null
      }
    },
    startAnimation () {
      let time = 0
      const animation = (t) => {
        const diff = t - time
        time = t
        const mathDistance = this.speed * (diff / 1000) * -1
        this.translateX += (mathDistance || 0)
        while (this.cycleWidth > 0 && this.translateX <= this.cycleWidth * -1) {
          this.translateX += this.cycleWidth
        }
        this.animationFrameId = requestAnimationFrame(animation)
      }
      this.animationFrameId = requestAnimationFrame(animation)
    },
    async initializeMarquee () {
      this.stopAnimation()

      if (!this.message.length) {
        this.translateX = 0
        this.cycleWidth = 0
        return
      }

      this.repeatCount = 2
      await this.$nextTick()

      const root = this.$refs.root
      const view = this.$refs.view

      await mountedCheck(root)

      let items = Array.from(view.children)
      items.forEach(item => {
        item.style.width = ''
      })

      const baseItems = items.slice(0, this.message.length)
      const baseWidths = baseItems.map(item => Math.ceil(item.getBoundingClientRect().width) + 1)
      const cycleWidth = baseWidths.reduce((sum, width) => sum + width, 0)

      if (!cycleWidth) {
        this.translateX = 0
        this.cycleWidth = 0
        return
      }

      const minRepeatCount = Math.max(2, Math.ceil((root.offsetWidth + cycleWidth) / cycleWidth))
      if (minRepeatCount !== this.repeatCount) {
        this.repeatCount = minRepeatCount
        await this.$nextTick()
        items = Array.from(this.$refs.view.children)
      }

      items.forEach((item, index) => {
        item.style.width = `${baseWidths[index % this.message.length]}px`
      })

      view.style.width = `${cycleWidth * this.repeatCount}px`
      this.cycleWidth = cycleWidth
      this.translateX = this.start
      this.startAnimation()
    }
  },
  render (h) {
    return h('div', {
      ref: 'root',
      class: classNames('marquee', {
        'marquee--single': this.isSingleMessage
      })
    }, [
      h('div', {
        ref: 'view',
        class: classNames('marquee-view'),
        style: {
          transform: `translateX(${this.translateX}px)`
        }
      }, [
        this.repeatedMessages.map((msg, index) => {
          return h('div', {
            key: `${index}-${msg}`,
            class: classNames('marquee-item'),
            domProps: {
              innerHTML: msg
            }
          })
        })
      ])
    ])
  }
}
